import React from 'preact/compat';

import Navigation from './Navigation';
import DefaultApi from '../Api/index';
import StructureApi from '../Api/StructureApi';
import translator from '../Api/Translator';

const NavigationType = {
    SECTION: 'section',
    MAIN: 'main',
    STRUCTURAL: 'structure',
};

export default class Flyout extends React.Component {
    constructor(props) {
        super(props);

        const currentUrl = window.location.origin + window.location.pathname;
        const currentPath = currentUrl.replace(window.PORTAL_URL, '');
        // fetch root determined by breadcrumb navigation for determining active navigation
        const rootPath = document.getElementById('nav-breadcrumbs')?.dataset.breadcrumbsRoot || '';
        this.sectionActive = rootPath && rootPath !== '/' && currentPath.startsWith(rootPath);
        this.auth = document.body.classList.contains('userrole-authenticated');

        // always init main api with the current path, constructur will determine root path
        this.mainApi = new DefaultApi(2, '/', this.auth, !this.sectionActive);

        // init section api with empty root path when not active
        this.sectionApi = new DefaultApi(2, (this.sectionActive && rootPath) || '', this.auth, this.sectionActive);

        // api for structural navigation
        this.structuralApi = new StructureApi(2, '/', this.auth, false);

        this.state = {
            openNavigation: this.sectionActive ? NavigationType.SECTION : NavigationType.MAIN,
            // true, if the navigation loaded their initial tree
            everythingLoaded: false,
            flyoutOpen: false,
        };

        this.internavOpen = this.internavOpen.bind(this);
        this.internavLoaded = this.internavLoaded.bind(this);
        this.checkNavReady = this.checkNavReady.bind(this);

        this.loadedNavigationsCounter = 0;
        this.translatorReady = false;

        // Verify, that the translator is ready to be used.
        translator.ready.then(() => {
            this.translatorReady = true;
            this.checkNavReady();
        });

        // navigation panel closes
        document.addEventListener('close.tud.navigation-panel', () => {
            this.setState({
                flyoutOpen: false,
                openNavigation: this.sectionActive ? NavigationType.SECTION : NavigationType.MAIN,
            });
        });

        // navigation panel opens
        document.addEventListener('open.tud.navigation-panel', () => {
            this.setState({
                flyoutOpen: true,
            });
        });
    }

    /**
     * Set the currently open navigation tree
     */
    internavOpen(opener) {
        this.setState({
            openNavigation: opener,
        });
    }

    /**
     * Called whenever the tree loaded for a navigation.
     */
    internavLoaded() {
        this.loadedNavigationsCounter += 1;
        this.checkNavReady();
    }

    /**
     * Decide here, when all navigations are ready to be shown.
     */
    checkNavReady() {
        const target = this.sectionActive ? 3 : 2;
        if (this.loadedNavigationsCounter === target && this.translatorReady) {
            this.setState({
                everythingLoaded: true,
            });
        }
    }

    render() {
        const internav = {
            internavOpen: this.internavOpen,
            internavLoaded: this.internavLoaded,
        };

        // collect the configs for our accordions
        let accordions = [];

        // main navigation
        accordions.push({ id: NavigationType.MAIN, api: this.mainApi });

        // section navigation
        if (this.sectionActive) {
            accordions.push({ id: NavigationType.SECTION, api: this.sectionApi });
        }

        // structural navigation
        accordions.push({ id: NavigationType.STRUCTURAL, api: this.structuralApi });

        const loading = this.state.everythingLoaded ? null : (
            <li>
                <div className="title loading">
                    Loading &hellip;
                </div>
            </li>
        );

        // actually create jsx from our configs
        this.accordions = accordions.map(({ id, api }) => (
            <Navigation
                open={this.state.openNavigation === id}
                api={api}
                cssClass={`navigation-${id}`}
                navId={id}
                internav={internav}
                visible={this.state.everythingLoaded}
                flyoutOpen={this.state.flyoutOpen}
            />
        ));

        return (
            <ul className="navigation-top">
                {this.accordions}
                {loading}
            </ul>
        );
    }
}
